<template>
    <section class="content">
        <div class="container-fluid">
            <loader v-if="loading" :type="'table'"/>
            <div v-else>
                <div class="row">
                    <div class="col-12">
                        <h1>{{translate('messages.chamber_searches')}}</h1>
                    </div>
                </div>
                <div class="row">
                    
                    <div class="col-12">
                        
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">{{translate('messages.chamber_searches_list')}}</h3>
                                
                                <div class="card-tools">
                                    <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                        <i class="fa fa-plus-square"></i>
                                        {{translate('messages.add_new')}}
                                    </button>
                                </div>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>{{translate('messages.keyword')}}</th>
                                            <th>{{translate('messages.type')}}</th>
                                            <th>{{translate('messages.date_order')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="chamber_search in chamber_searches.data" :key="'chamber_search-'+chamber_search.id">
                                            
                                            <td>{{chamber_search.keyword}}</td>
                                            <td>{{translate('messages.'+chamber_search.type)}}</td>
                                            <td>{{chamber_search.order}}</td>
                                            <td>
                                                
                                                <a @click="editModal(chamber_search)" class="btn btn-link mb-1" v-tooltip:top="translate('messages.update')" data-toggle="tooltip">
                                                    <i class="fa fa-edit blue"></i>
                                                </a>
                                                
                                                <a @click="deleteChamberSearch(chamber_search.id)" class="btn btn-link mb-1" v-tooltip:top="translate('messages.delete')" data-toggle="tooltip">
                                                    <i class="fa fa-trash red"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="!chamber_searches.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                            </div>
                            <!-- /.card-body -->
                            <div class="card-footer">
                                <pagination :limit="10" :data="chamber_searches" @pagination-change-page="getResults"></pagination>
                            </div>
                        </div>
                        <!-- /.card -->
                    </div>
                </div>
            </div>
            
            <!-- Modal -->
            <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-show="!editmode">{{translate('messages.create_chamber_search')}}</h5>
                            <h5 class="modal-title" v-show="editmode">{{translate('messages.update_chamber_search')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        
                        <form @submit.prevent="editmode ? updateChamberSearch() : createChamberSearch()">
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>{{translate('messages.keyword')}}</label>
                                    <input v-model="form.keyword" type="text" name="keyword"
                                    class="form-control" :class="{ 'is-invalid': form.errors.has('keyword') }">
                                    <has-error :form="form" field="keyword"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>{{translate('messages.type')}}</label>
                                    <select class="form-control" v-model="form.type" :class="{ 'is-invalid': form.errors.has('type') }">
                                        <option 
                                        v-for="search_type in types" :key="'type-'+search_type"
                                        :value="search_type"
                                        :selected="search_type == form.type">{{translate('messages.'+search_type)}}</option>
                                    </select>
                                    <has-error :form="form" field="type"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>{{translate('messages.date_order')}}</label>
                                    <select class="form-control" v-model="form.order" :class="{ 'is-invalid': form.errors.has('order') }">
                                        <option value="desc">{{translate('messages.descendent')}}</option>
                                        <option value="asc">{{translate('messages.ascendent')}}</option>
                                    </select>
                                    <has-error :form="form" field="order"></has-error>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                                <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    data () {
        return {
            editmode: false,
            chamber_searches : {},
            form: new Form({
                id : '',
                keyword: '',
                type: '',
                order: 'desc'
            }),
            loading : true,
            types: [],
            page : 1
        }
    },
    methods: {
        
        getResults(page = 1) {
            
            this.$Progress.start();
            this.page = page;
            axios.get('/api/chamberSearch?page=' + page).then(({ data }) => {
                this.chamber_searches = data.data;
                this.loading = false;
                this.$Progress.finish();
                if(!this.chamber_searches.data.length && this.page > 1){
                    this.getResults(this.page - 1);
                }
            });
        },
        loadTypes(){
            axios.get("/api/chamberSearch/types").then(({ data }) => {this.types = data.data;});
        },
        editModal(chamber_search){
            this.editmode = true;
            this.form.reset();
            this.form.errors.clear();
            this.form.fill(chamber_search);
            $('#addNew').modal('show');
        },
        newModal(){
            this.editmode = false;
            this.form.reset();
            this.form.errors.clear();
            $('#addNew').modal('show');
        },
        createChamberSearch(){
            this.$Progress.start();
            this.form.update({_method:'post'});
            this.form.post('/api/chamberSearch')
            .then((response)=>{
                $('#addNew').modal('hide');
                
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                this.$Progress.finish();
                this.getResults();
            })
            .catch((error)=>{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
            })
        },
        updateChamberSearch(){
            this.$Progress.start();
            this.form.update({_method:'put'});
            
            this.form.post('/api/chamberSearch/'+this.form.id)
            .then((response) => {
                // success
                $('#addNew').modal('hide');
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                this.$Progress.finish();
                //  Fire.$emit('AfterCreate');
                this.getResults(this.page);
            })
            .catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
            });
            
        },
        deleteChamberSearch(id){
            Swal.fire({
                title: window.translate('messages.are_you_sure'),
                text: window.translate('messages.no_revert'),
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                cancelButtonText: window.translate('messages.cancel'),
                confirmButtonText: window.translate('messages.delete_confirm')
            })
            .then((result) => {
                // Send request to the server
                if (result.value) {
                    this.$Progress.start();
                    this.form.delete('/api/chamberSearch/'+id).then((response)=>{
                        this.$Progress.finish();
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        // Fire.$emit('AfterCreate');
                        this.getResults(this.page);
                    }).catch((error)=> {
                        let error_obj = JSON.parse(error.request.response);
                        let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                        if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                        Toast.fire({
                            icon: 'error',
                            title: error_title
                        });
                        this.$Progress.fail();
                    });
                }
            })
        }
    },
    mounted() {
        $('#addNew').on('hide.bs.modal', function () {
            $('[data-toggle="popover"]').popover('hide');
        });
    },
    created() {
        this.loadTypes();
        this.getResults();
    }
}
</script>
